module.exports = __webpack_public_path__ + "img/badgesex150_40_3_white.f5d2170a.png";